module.exports = __webpack_public_path__ + "img/agence-actif.9e0a0bbb.svg";